import React, { useEffect, useRef } from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import type { LoanFile } from '../../types/files';
interface DeleteDialogProps {
  files: LoanFile[];
  onCancel: () => void;
  onConfirm: () => void;
}
export function DeleteDialog({
  files,
  onCancel,
  onConfirm
}: DeleteDialogProps) {
  const confirmRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    confirmRef.current?.focus();
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onCancel();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onCancel]);
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-4" data-mp="1703b6p8dob3u">
      <div className="absolute inset-0 bg-slate-900/40" onClick={onCancel} aria-hidden="true" data-id="element-5" data-mp="16y0b1cdih1le" />
      <div role="dialog" aria-modal="true" aria-labelledby="delete-files-title" className="relative w-full max-w-md rounded bg-white p-5 shadow-xl" data-id="element-6" data-mp="38rg4si4wawkl">
        <div className="flex items-start gap-3" data-id="element-7" data-mp="2mmurzo68tbcc">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-700" data-id="element-8" data-mp="2rottesif9y6n">
            <AlertTriangleIcon className="h-5 w-5" aria-hidden="true" data-id="element-9" data-mp="2vnt0ainps50q" />
          </span>
          <div data-id="element-10" data-mp="30gvt2oko3afv">
            <h2 id="delete-files-title" className="text-base font-semibold text-slate-900" data-id="element-11" data-mp="30hdmldfy3ak3">
              Delete {files.length} {files.length === 1 ? 'file' : 'files'}?
            </h2>
            <p className="mt-1 text-sm text-slate-600" data-id="element-12" data-mp="3fdd57i0okt3h">
              Deleted files are moved to the Recycle Bin and removed from this
              loan record. Compliance documents may need to be re-collected from
              the borrower.
            </p>
          </div>
        </div>

        <ul className="mt-4 max-h-40 space-y-1 overflow-y-auto rounded border border-slate-200 bg-slate-50 p-2 text-sm text-slate-700" data-id="element-13" data-mp="1l1olz3nf24da">
          {files.map(file => <li key={file.id} className="truncate" data-id="element-14" data-mp="2sccvfrl35onl">
              {file.title}.{file.extension}
            </li>)}
        </ul>

        <div className="mt-5 flex justify-end gap-2" data-id="element-15" data-mp="31cj5f3hks6i0">
          <button type="button" onClick={onCancel} className="rounded border border-slate-300 bg-white px-3 py-1.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0176d3] focus-visible:ring-offset-2" data-id="element-16" data-mp="31daudvgo35zb">
            Cancel
          </button>
          <button ref={confirmRef} type="button" onClick={onConfirm} className="rounded bg-red-600 px-3 py-1.5 text-sm font-semibold text-white transition hover:bg-red-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-600 focus-visible:ring-offset-2" data-id="element-17" data-mp="3l10bn8qz9nua">
            Delete
          </button>
        </div>
      </div>
    </div>;
}